import React from "react";
import "../styles/Services.scss";

import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";
import img3 from "../images/services/3.png";
import img4 from "../images/services/5.png";
import img5 from "../images/services/7.png";

export default function Services() {
  return (
    <section className="ovit-services" id="ovit-services">
      <div className="ovit-services__container">
        <header className="ovit-services__header">
          <h2 className="ovit-services__title">
            Nuestros <span>Servicios</span>
          </h2>
          <p className="ovit-services__subtitle">
            Soluciones enfocadas en ventas, automatización y crecimiento
            digital.
          </p>
        </header>

        <div className="ovit-services__grid">
          {/* SERVICIO PRINCIPAL */}
          <div className="ovit-card ovit-card--featured">
            <div className="ovit-card__image">
              <img src={img1} alt="Contenido y campañas publicitarias" />
            </div>

            <div className="ovit-card__body">
              <div className="ovit-card__price">Desde $799</div>

              <h3>Contenido + Campañas Publicitarias</h3>

              <p>
                Gestión completa de redes sociales y anuncios en Facebook.
                Estrategia enfocada en generar ventas reales desde el primer
                mes.
              </p>

              <a
                href="https://ovitsolucionesweb.com/planes"
                className="ovit-card__btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Más info →
              </a>
            </div>
          </div>

          {/* LANDINGS */}
          <div className="ovit-card">
            <div className="ovit-card__image">
              <img src={img2} alt="Landing pages y páginas web" />
            </div>

            <div className="ovit-card__body">
              <h3>Landing Pages y Páginas Web</h3>

              <p>
                Diseños modernos optimizados para conversión. Convierte
                visitantes en clientes con páginas estratégicas.
              </p>

              <a
                href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20p%C3%A1ginas%20web%20y%20landing%20pages.%20Me%20gustar%C3%ADa%20cotizar%20mi%20proyecto.
"
                className="ovit-card__btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Más info →
              </a>
            </div>
          </div>

          {/* SAAS */}
          <div className="ovit-card">
            <div className="ovit-card__image">
              <img src={img3} alt="Aplicaciones web SaaS" />
            </div>

            <div className="ovit-card__body">
              <h3>Aplicaciones Web Tipo SaaS</h3>

              <p>
                Plataformas personalizadas para escalar tu negocio, automatizar
                procesos y mejorar la experiencia del cliente.
              </p>

              <a
                href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20desarrollar%20una%20aplicaci%C3%B3n%20web%20personalizada.%20Mi%20idea%20es%20%5Bdescribe%20brevemente%20tu%20proyecto%5D%20y%20quiero%20recibir%20una%20propuesta.
"
                className="ovit-card__btn"
              >
                Más info →
              </a>
            </div>
          </div>

          {/* AGENTES IA */}
          <div className="ovit-card">
            <div className="ovit-card__image">
              <img src={img4} alt="Agentes IA y chatbots" />
            </div>

            <div className="ovit-card__body">
              <h3>Agentes IA en FB Messenger</h3>

              <p>
                Automatiza la atención de tus campañas con bots inteligentes
                conectados a Facebook Messenger 24/7.
              </p>

              <a
                href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20automatizar%20la%20atenci%C3%B3n%20de%20mis%20campañas%20con%20un%20bot%20inteligente.%20Me%20gustar%C3%ADa%20saber%20m%C3%A1s%20sobre%20sus%20servicios%20de%20agentes%20IA."
                className="ovit-card__btn"
              >
                Más info →
              </a>
            </div>
          </div>

          {/* N8N */}
          <div className="ovit-card">
            <div className="ovit-card__image">
              <img src={img5} alt="Automatización con n8n" />
            </div>

            <div className="ovit-card__body">
              <h3>Automatización con n8n</h3>

              <p>
                Conectamos herramientas y sistemas para eliminar tareas
                repetitivas y optimizar tu flujo de trabajo.
              </p>

              <a
                href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20automatizar%20mis%20procesos%20con%20n8n.%20Me%20gustar%C3%ADa%20saber%20m%C3%A1s%20sobre%20sus%20servicios%20de%20automatizaci%C3%B3n."
                className="ovit-card__btn"
              >
                Más info →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
